import axios from "axios";
// import React, { useEffect, useState } from "react";
import { useEffect, useState } from "react";

import { OAUTH_CONFIG } from "../config";
// import { useIsAuth } from "../context/AuthContext";
import SymbolSearch from "./SymbolSearch";

const Symbols = () => {
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(false);

    const [selectedSymbol, setSelectedSymbol] = useState<any | null>(null);
    const [selectedSymbolOptions, setSelectedSymbolOptions] = useState<
        any | null
    >(null);

    const api = axios.create({ baseURL: OAUTH_CONFIG.backUrl });

    useEffect(() => {
        if (!selectedSymbol?.symbolId) return;
        fetchSymbol();
        fetchSymbolOptions();
    }, [selectedSymbol?.symbolId]);

    // useEffect(() => {
    //     if (!selectedSymbol?.symbolId) return;
    //     // fetchSymbol();
    //     fetchSymbolOptions();
    // }, [selectedSymbol?.symbolId]);

    const fetchSymbol = async () => {
        setError(null);

        try {
            setLoading(true);
            const response = await api.get(
                `/symbols/${selectedSymbol?.symbolId}`,
            );
            const symbolResponse = response.data.symbols;

            setSelectedSymbol(symbolResponse);
        } catch (error: any) {
            if (error.name !== "CanceledError") {
                console.error(error);
            }
        } finally {
            setLoading(false);
        }
    };

    const fetchSymbolOptions = async () => {
        setError(null);

        try {
            setLoading(true);
            const response = await api.get(
                `/symbols/${selectedSymbol?.symbolId}/options`,
            );
            const symbolOptionsResponse = response.data.optionChain;
            console.log("fetchSymbolOptions response:", symbolOptionsResponse);

            setSelectedSymbolOptions(symbolOptionsResponse);
        } catch (error: any) {
            if (error.name !== "CanceledError") {
                console.error(error);
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <SymbolSearch onSelect={setSelectedSymbol} />

            {selectedSymbol && (
                <div className="card mt-3">
                    <div className="card-body">
                        <h5 className="card-title">{selectedSymbol.symbol}</h5>
                        <p className="card-text">
                            {selectedSymbol.description}
                        </p>
                    </div>
                    <pre className="mt-3">
                        {JSON.stringify(selectedSymbol, null, 2)}
                    </pre>
                    <div className="card-body">
                        <h5 className="card-title">{selectedSymbol.symbol}</h5>
                        <p className="card-text">
                            {selectedSymbol.description}
                        </p>
                        <h4>Options</h4>
                        <pre className="mt-3">
                            {JSON.stringify(selectedSymbolOptions, null, 2)}
                        </pre>
                    </div>
                </div>
            )}
            {selectedSymbolOptions && (
                <div className="card-body">
                    <h4>Options 2</h4>
                    <pre className="mt-3">
                        {JSON.stringify(selectedSymbolOptions, null, 2)}
                    </pre>
                </div>
            )}
        </div>
    );
};

export default Symbols;
